/**
 * Capitalises the first letter of a given string
 * @param {String} string
 */
export const capitalise = string => string.charAt(0).toUpperCase() + string.slice(1);
